import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    currentUserId: null,
    appHydrated: false
};

export default {mutations, actions, state}